import { FeatureCollection } from 'geojson';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'route-geo-json';

export class RouteGeoJsonController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getRouteGeoJsonForShipment(
    shipmentId: number,
  ): Promise<FeatureCollection | null> {
    const response = await this.http.get<FeatureCollection | null>(
      `${shipmentId}`,
    );
    return response.data;
  }
}
